import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream pt-24 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-83">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C9A84C 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-84"></div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} data-id="element-86">
          <div className="flex items-center gap-2 mb-6" data-id="element-87">
            <div className="flex text-gold" data-id="element-88">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-89" />)}
            </div>
            <span className="text-sm font-medium text-leather-warm" data-id="element-90">
              Verificado por Compradores
            </span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-5xl font-bold text-leather-dark leading-tight mb-6" data-id="element-91">
            Domina el Arte de la Marroquinería y Crea Proyectos Premium con una
            Biblioteca Exacta de Más de 200 Patrones Profesionales
          </h1>
          <p className="text-lg sm:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-92">
            Descubre EXACTAMENTE cómo ensamblar cada pieza sin adivinar y logra
            con estas +200 Plantillas que cada trozo de cuero costoso se
            convierta en una obra de arte impecable.
          </p>
          <div className="flex flex-wrap gap-3 mb-8" data-id="element-93">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-leather-warm/10 text-leather-dark text-sm font-medium" data-id="element-94">
              <CheckCircle2 className="w-4 h-4 text-leather-warm" data-id="element-95" />
              Archivos Listos para Imprimir
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-leather-warm/10 text-leather-dark text-sm font-medium" data-id="element-96">
              <CheckCircle2 className="w-4 h-4 text-leather-warm" data-id="element-97" />
              200+ Patrones
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-leather-warm/10 text-leather-dark text-sm font-medium" data-id="element-98">
              <CheckCircle2 className="w-4 h-4 text-leather-warm" data-id="element-99" />6 Guías
              Técnicas
            </span>
          </div>
          <motion.a href="#soluciones" animate={{
          boxShadow: ['0px 0px 0px rgba(201,168,76,0)', '0px 0px 20px rgba(201,168,76,0.6)', '0px 0px 0px rgba(201,168,76,0)']
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-block w-full sm:w-auto text-center bg-gold hover:bg-gold-hover text-darktext font-bold text-lg px-8 py-4 rounded-xl shadow-lg transform transition hover:-translate-y-1" data-id="element-100">
            QUIERO MI BIBLIOTECA DE PATRONES »
          </motion.a>
          <p className="mt-4 text-sm text-gray-600 flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-2" data-id="element-101">
            <span data-id="element-102">Descarga inmediata</span>
            <span className="hidden sm:inline" data-id="element-103">·</span>
            <span data-id="element-104">Pago único</span>
            <span className="hidden sm:inline" data-id="element-105">·</span>
            <span data-id="element-106">Acceso Ilimitado</span>
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15,
        delay: 0.2
      }} className="relative" data-id="element-107">
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/3s3qfvaqrWJDEjFCWFPQRx/Gemini_Generated_Image_2vg0n22vg0n22vg0_(1).webp" alt="200+ Patrones de Cuero" className="w-full h-auto" data-id="element-109" />
          </motion.div>
          <div className="absolute -bottom-6 -left-6 bg-white p-5 rounded-xl shadow-xl border border-gray-100 hidden sm:block" data-id="element-110">
            <p className="font-heading font-bold text-leather-dark text-3xl" data-id="element-111">
              200+
            </p>
            <p className="text-sm text-gray-600 font-medium" data-id="element-112">Patrones listos</p>
          </div>
        </motion.div>
      </div>
    </section>;
}